export const ABOUT_CONTAINER_TAG_NAME = 'about-container';
